import { render, staticRenderFns } from "./CoursewareActivityItem.vue?vue&type=template&id=fe982db8&"
import script from "./CoursewareActivityItem.vue?vue&type=script&lang=js&"
export * from "./CoursewareActivityItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports